
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recrutamento",
      function () {
        return require("private-next-pages/recrutamento/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recrutamento"])
      });
    }
  